<template>
  <div id="app" v-loading.fullscreen.lock="pageLoading"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.7)">
    <!-- 登出按鈕 -->
    <div style="position: absolute; left: 20px; top: 15px;">
      <el-button @click="gotoCheckout" plain>{{ $t('Store.back') }}</el-button>
    </div>
    <!-- 分類選單 -->
    <div style="padding-top: 20px;">
      <el-radio-group v-model="radio" fill="#666" @change="changeTab">
        <el-radio-button label="ComsumeHistory">{{ $t('Store.consumption') }}</el-radio-button>
        <el-radio-button label="ExchangeHistory">{{ $t('Store.redeem') }}</el-radio-button>
        <el-radio-button label="SendHistory">{{ $t('Store.topup') }}</el-radio-button>
        <el-radio-button label="Undo">{{ $t('Store.cancel') }}</el-radio-button>
      </el-radio-group>
      <!-- 查詢電話 -->
      <mu-text-field v-model="searchPhone" style="width: 180px; margin-left: 40px;" action-icon="search" :placeholder="$t('Store.searchphone')"></mu-text-field>
      <br>
      <div style="padding-left: 10px; padding-bottom: 10px;">
        <el-radio-group v-model="undoType" v-if="radio === 'Undo'">
          <el-radio label="UndoHistory">{{ $t('Store.consumption') }}</el-radio>
          <el-radio label="UndoExchange">{{ $t('Store.redeem') }}</el-radio>
          <el-radio label="UndoSend">{{ $t('Store.topup') }}</el-radio>
        </el-radio-group>
      </div>
      <div class="block">
        <!-- 起始日 -->
        <el-date-picker v-model="start"
          style="width: 150px;"
          align="right"
          type="date"
          placeholder="選擇起始日"
          :picker-options="pickerOptions">
        </el-date-picker> -
        <!-- 到期日 -->
        <el-date-picker v-model="end"
          align="right"
          style="width: 150px; margin-right: 10px;"
          type="date"
          placeholder="選擇到期日"
          :picker-options="pickerOptions">
        </el-date-picker>
        <el-button type="primary" @click="getHistory(radio, true)" :disabled="!start || !end">查詢</el-button>
      </div>
      <!-- 消費記錄 -->
      <div class="grid-content" v-if="showTable">
        <el-table ref="table" :key="Math.random()" :data="sortableList" :empty-text="$t('Store.noinfo')" :height="windowHeight" style="width: 100%">
          <!-- 時間 -->
          <el-table-column prop="Time" :label="$t('Store.time')" width="200">
            <template slot-scope="scope">{{ scope.row ? getTime(scope.row[1].Time) : '' }}</template>
          </el-table-column>
          <!-- 電話 -->
          <el-table-column prop="Phone" :label="$t('Store.phone')" width="130">
            <template slot-scope="scope">{{ scope.row ? scope.row[1].Phone : '' }}</template>
          </el-table-column>
          <!-- 金額 -->
          <el-table-column prop="Price" :label="$t('Store.amount')" v-if="radio === 'ComsumeHistory' || (radio === 'Undo' && undoType === 'UndoHistory')">
            <template slot-scope="scope">
              <span style="font-weight: 500; font-size: 15px;" :style="{ color: (scope.row && scope.row[1].Price < 0) ? style.red : style.default }">
                {{ scope.row ? scope.row[1].Price : '' }}
              </span>
            </template>
          </el-table-column>
          <!-- 點數 -->
          <el-table-column prop="Point" :label="$t('Store.point')" v-if="checkEnable()">
            <template slot-scope="scope"><span style="font-weight: 500; font-size: 15px;">{{ scope.row[1].Point }}</span></template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column prop="Edit" width="180" :label="$t('Store.operate')" v-if="radio === 'ComsumeHistory'">
            <template slot-scope="scope">
              <el-button size="mini" type="info" v-if="scope.row && scope.row[1].Status === 'refund'" disabled>{{ $t('Store.refunded') }}</el-button>
              <el-button size="mini" @click="checkReverse(scope.row, 'Refund')" type="primary" v-if="scope.row && scope.row[1].Price > 0 && scope.row[1].Status !== 'refund'">{{ $t('Store.refund') }}</el-button>
              <el-button size="mini" @click="checkReverse(scope.row, 'comsume')" type="danger" v-if="scope.row && scope.row[1].Status !== 'refund'">{{ $t('Store.cancel') }}</el-button>
            </template>
          </el-table-column>
          <!-- 兑點操作 -->
          <el-table-column prop="Edit" width="180" :label="$t('Store.operate')" v-if="radio === 'ExchangeHistory'">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="checkReverse(scope.row, 'exchange')">{{ $t('Store.cancel') }}</el-button>
            </template>
          </el-table-column>
          <!-- 贈點操作 -->
          <el-table-column prop="Edit" width="180" :label="$t('Store.operate')" v-if="radio === 'SendHistory'">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="checkReverse(scope.row, 'send')">{{ $t('Store.cancel') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 取消 Dialog -->
      <mu-dialog :title="$t('Store.system')" width="600" :open="reverseDia">
        <!-- 驗證碼 -->
        <el-input type="password" :placeholder="$t('Store.please_ver')" v-model="verCode" @focus="type = 'vercode'">
          <template slot="prepend">{{ $t('Store.vercode') }}</template>
        </el-input>
        <!-- 店員編號 -->
        <el-input :placeholder="$t('Store.please_employee')" v-model="employee" @focus="type = 'employee'">
          <template slot="prepend">{{ $t('Store.employee') }}</template>
        </el-input>
        <!-- 鍵盤 -->
        <keyboard @addNum="addNum" @clear="clear"/>
        <!-- 按鈕 -->
        <mu-button slot="actions" flat color="primary" @click="reverseDia = false">{{ $t('Store.back') }}</mu-button>
        <mu-button slot="actions" color="primary" @click="sendReverse">{{ $t('Store.check') }}</mu-button>
        <!-- 錯誤文字 -->
        <div style="color: #f24;">{{ $t(noVer) }}</div>
        <div style="color: #f24;">{{ $t(noEmployee) }}</div>
      </mu-dialog>
      <!-- 成功取消 -->
      <mu-dialog :title="$t('Store.system')" width="600" :open.sync="reverseSuccessDia">
        已成功取消此筆交易
      </mu-dialog>
      <!-- 選單 -->
      <!-- <el-pagination background
        v-if="showPageTab"
        @current-change="changePage"
        style="margin-top: 10px;"
        :page-size="1"
        layout="prev, pager, next"
        :total="totalNum">
      </el-pagination> -->
      <div style="position: relative; margin-top: 15px; margin-bottom: 50px;">
        <mu-pagination @change="changePage" style="position: absolute; left: 50%; transform: translateX(-50%);" raised circle :total="totalLength" :current.sync="pageTab"></mu-pagination>
      </div>
      <!-- 重整頁面 -->
      <div style="text-align: center; padding-top: 15px;">
        <el-button type="info" @click="getHistory(radio, true)">{{ $t('Store.refresh') }}
          <i class="el-icon-refresh"></i>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from 'vuex';
import keyboard                   from '../page/keyboard';

export default {
  data() {
    return {
      pageLoading: false,
      showTable: false,
      showLastBar: false,
      showPageTab: false,
      auth: this.$route.params.Auth_u,
      storeid: this.$route.query.storeid,
      radio: 'ComsumeHistory',
      searchPhone: '',
      undoType: 'UndoHistory',
      page: {
        ratio: 50,
        expRatio: 0,
        taxID: '',
        fbid: '',
        lineid: ''
      },
      user: {},
      style: {
        default: '#666',
        red: '#f24'
      },
      tableData: {},
      lists: [],
      finalList: [],
      sortableList: [],
      pageTab: 1,
      totalNum: 0,
      totalLength: 0,
      lists2: [],
      reverseDia: false,
      reverseType: '',
      reverseData: {},
      reverseSuccessDia: false,
      verCode: '',
      employee: '',
      noVer: '',
      noEmployee: '',
      windowHeight: window.screen.height * 0.45,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      start: Date.now(),
      end: Date.now()
    };
  },
  components: {
    keyboard
  },
  mounted() {
    this.getAccData();
  },
  methods: {
    ...mapActions({
      checkAccount     : 'checkAccount',
      getAllHistory    : 'getAllHistory',
      reverseComsume   : 'reverseComsume',
      setHistory       : 'setHistory',
      comsumeBroadcast : 'comsumeBroadcast',
      getSuccessMessage: 'getSuccessMessage',
      getUserByPhoneNum: 'getUserByPhone'
    }),
    gotoCheckout() {
      this.$router.push(`/checkout/${this.auth}?storeid=${this.storeid}`);
    },
    checkEnable() {
      if (this.radio === 'ComsumeHistory') {
        return false;
      }
      if (this.radio === 'Undo' && this.undoType === 'UndoHistory') {
        return false;
      }
      return true;
    },
    changePage(val) {
      this.pageTab = val;
      this.sortableList = [];
      this.sortableList = this.finalList[this.pageTab - 1];
    },
    addNum(val) {
      if (this.type === 'vercode')  this.verCode  += val;
      if (this.type === 'employee') this.employee += val;
    },
    clear() {
      if (this.type === 'vercode')  this.verCode  = '';
      if (this.type === 'employee') this.employee = '';
    },
    // 取得日期格式
    getTime(time) {
      const realTime = new Date(time);
      return realTime.toLocaleString('en-US', { timeZone: this.timezone });
    },
    // 查詢用戶
    getUserByPhone(phone) {
      this.pageLoading = true;
      this.user = { fbtoken: '', linetoken: '', eilisid: '', truephone: '', newpoint: '', points: '', userpoint: '', hasLINE: false, hasFB: false };
      const validPhone = phone.trim();
      this.getUserByPhoneNum({ service: 'LINE', auth: this.page.lineid, phone: validPhone })
        .then((res) => {
          this.getUserByPhoneNum({ service: 'FB', auth: this.page.fbid, phone: validPhone })
            .then((resp) => {
              this.pageLoading = false;
              if (res.id) {
                this.user.hasLINE   = true;
                this.user.linetoken = res.id;
                this.user.points    = res.Point;
              }
              if (resp.id) {
                this.user.hasFB   = true;
                this.user.fbtoken = resp.id;
                this.user.points  = resp.Point;
              }
              this.reverseDia = true;
            })
        })
    },
    changeTab(val) {
      this.showPageTab = false;
      this.getHistory(val, true);
    },
    checkReverse(val, type) {
      this.getUserByPhone(val[1].Phone);
      this.reverseType = type;
      this.reverseData = val;
      this.employee = '';
      this.verCode = '';
      this.noVer = '';
      this.noEmployee = '';
    },
    sendComsume(service, auth, token, type, newpoints) {
      const msgType = (type === 'comsume') ? 'Undo' : (type === 'Refund') ? 'Refund' : 'UnExchange';
      this.getSuccessMessage({ service, auth, type: msgType })
        .then((_msg) => {
          const successResponse = _msg.replace(/@ELS_REMAIN/g, newpoints);
          this.comsumeBroadcast({ service, auth, token, message: successResponse });
        })
    },
    pushReverse(service, phone, newpoints, points, returnExp, key, type, detail) {
      this.pageLoading = true;
      let auth  = '';
      let token = '';
      if (service === 'FB') {
        auth  = this.page.fbid;
        token = this.user.fbtoken;
      }
      if (service === 'LINE') {
        auth  = this.page.lineid;
        token = this.user.linetoken;
      }
      this.reverseComsume({ service, auth, token, point: points, returnExp: returnExp, store: this.storeid, key, undoType: type, employee: this.employee })
        .then(() => {
          this.pageLoading = false;
          this.reverseSuccessDia = true;
          this.getHistory(this.radio, true);
          // 傳訊息
          this.sendComsume(service, auth, token, type, newpoints);
          // 寫紀錄
          if (service === 'FB' && this.user.hasLINE) {
            let storeRefund = null;
            let userRefund  = 'none';
            if (type === 'Refund') {
              storeRefund = { Phone: phone, Price: detail.Price * -1, Time: Date.now() };
              userRefund  = { Price: detail.Price * -1, Store: this.storeid, Time: Date.now() };
            }
            if (type === 'comsume') {
              storeRefund = { Phone: phone, Price: detail.Price, Time: Date.now(), Employee: this.employee };
            }
            if (type === 'exchange' || type === 'send') {
              storeRefund = { Phone: phone, Point: points, Time: Date.now(), Employee: this.employee };
            }
            this.setHistory({ service: 'LINE', auth: this.page.lineid, token: this.user.linetoken, key, store: this.storeid, type: this.undoType, storedetail: storeRefund, userdetail: userRefund });
          }
        })
    },
    sendReverse() {
      if (this.verCode !== this.page.taxID) {
        this.noVer = 'Store.warning2';
        return;
      } 
      else {
        this.noVer = '';
      }
      if (this.employee === '') {
        this.noEmployee = 'Store.no_employee_id';
        return;
      } 
      else {
        this.noEmployee = '';
      }
      this.reverseDia = false;
      let newPoints = 0;
      let points = parseInt(this.reverseData[1].Point);
      let returnExp = 0;
      const userPoint = parseInt(this.user.points);
      // 計算點數
      if (this.reverseType === 'exchange') {
        newPoints = userPoint + points;
      } 
      else if (this.reverseType === 'send') {
        newPoints = userPoint - points;
      }
      else {
        newPoints = userPoint - parseInt(parseInt(this.reverseData[1].Price) / parseInt(this.page.ratio));
        points = parseInt(parseInt(this.reverseData[1].Price) / parseInt(this.page.ratio));
        returnExp = parseInt(this.reverseData[1].Price) * this.page.expRatio;
      }
      // 送出資料
      this.pushReverse(this.reverseData[1].Service, this.reverseData[1].Phone, newPoints, points, returnExp, this.reverseData[0], this.reverseType, this.reverseData[1]);
    },
    recalculateList() {
      this.totalNum = Math.floor(this.lists2.length / 10) + 1;
      this.totalLength = this.lists2.length;
      for (let i = 0; i < this.totalNum; i += 1) {
        this.finalList[i] = [];
      }
      for (let e = 0; e < this.lists2.length; e += 1) {
        const index = e;
        const group = parseInt(index / 10);
        const orderData = this.lists2[index];
        this.finalList[group].push(orderData)
      }
      this.showPageTab = true;
      this.sortableList = this.finalList[0];
    },
    getHistory(type, boolean) {
      this.pageLoading = true;
      this.showTable = false;
      this.totalNum  = 0;
      this.pageTab   = 1;
      this.finalList = [];
      this.lists     = [];
      this.lists2    = [];

      let path = '';
      if (type === 'Undo') {
        path = this.undoType;
      }
      else {
        path = type;
      }
      if (this.tableData[path] && this.tableData[path].length > 0 && !boolean) {
        this.pageLoading = true;
        this.lists  = this.tableData[path];
        this.lists2 = this.tableData[path];
        // 重新計算表單
        this.recalculateList();
        setTimeout(() => {
          this.pageLoading = false;
          this.showTable = true;
        }, 200);
      }
      else {
        this.pageLoading = true;
        let fbList = [];
        let lineList = [];
        const callStack = [
          { service: 'FB', auth: this.page.fbid },
          { service: 'LINE', auth: this.page.lineid }
        ];
        const promise = callStack.map((el) => this.getAllHistory({
          service: el.service, auth: el.auth, store: this.storeid ? this.storeid : 'NoName', path: path, start: new Date(this.start).getTime(), end: new Date(this.end).getTime() + (86400 * 1000)
        })
        .then((res) => {
          if (el.service === 'FB') {
            fbList = (res && res.filter(el => el[1].Service)) ? res.filter(el => el[1].Service === 'FB') : [];
          }
          else {
            lineList =  (res && res.filter(el => el[1].Service)) ? res.filter(el => el[1].Service === 'LINE') : [];
          }
        }));
        return Promise.all([...promise]).then(() => {
          this.showTable = true;
          this.pageLoading = false;
          this.tableData[path] = lineList.concat(fbList).sort((a, b) => b[1].Time - a[1].Time);
          this.lists = lineList.concat(fbList).sort((a, b) => b[1].Time - a[1].Time);
          this.lists2 = lineList.concat(fbList).sort((a, b) => b[1].Time - a[1].Time);
          this.recalculateList();
        })
      }
    },
    getAccData() {
      this.checkAccount({ Service: 'Double', Auth: this.auth })
      .then((res) => {
        if (res) {
          this.page.taxID = res.taxid ? res.taxid : '23055068';
          this.page.ratio = res.ratio ? parseInt(res.ratio) : 50;
          this.page.expRatio = res.expRatio ? res.expRatio : 0;
          this.page.fbid = res.Accounts.filter(el => el.service === 'FB')[0].id;
          this.page.lineid = res.Accounts.filter(el => el.service === 'LINE')[0].id;
        }
      });
    }
  },
  watch: {
    // 查詢記錄
    searchPhone(val) {
      this.lists2 = this.lists.filter(el => el[1].Phone && el[1].Phone.indexOf(val) !== -1);
      this.recalculateList();
    },
    undoType(val) {
      this.getHistory(this.radio);
    }
  }
}
</script>



<style scoped>
  @import url('https://fonts.googleapis.com/css?family=Poppins');
  .sendButton {
    background-color: #67c23a !important;
    color: #fff !important;
    border-radius: 0 3px 3px 0 !important;
    border: none !important;
  }
  .sendButton:hover {
    opacity: 0.8;
  }
  .el-input {
    margin-bottom: 25px;
  }
  .el-row {
    margin-bottom: 20px;
  }
  .el-col {
    padding: 0;
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #666;
  }
  .bg-purple {
    background: #777;
  }
  .bg-purple-light {
    background: #fff;
    border: 1px solid #777;
  }
  .grid-content {
    margin: 0 auto;
    border-radius: 4px;
    min-height: 36px;
    max-width: 630px;
    margin-bottom: 10px;
    text-align: left;
  }
  .web {
    text-decoration: none;
    color: black;
    transition: 0.2s;
  }
  .web:hover {
    color: #f24;
  }
</style>